export default "__VITE_ASSET__44f430b8__"